import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuthContext.tsx';

interface RequireAdminAuthProps {
  children: React.ReactNode;
}

const RequireAdminAuth: React.FC<RequireAdminAuthProps> = ({ children }) => {
  const { isAdminAuthenticated, isAdminLoading } = useAdminAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAdminLoading && !isAdminAuthenticated) {
      navigate('/admin/login');
    }
  }, [isAdminAuthenticated, isAdminLoading, navigate]);

  if (isAdminLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
        <p className="ml-4 text-gray-600">Loading admin session...</p>
      </div>
    );
  }

  if (!isAdminAuthenticated) {
    return null; // Will redirect via useEffect
  }

  return <>{children}</>;
};

export default RequireAdminAuth;
